<template>
  <div class="rew19_aro_wrap shop">
    <div class="rew19_contents_inner">
      <h2 class="rew19_second_title">나의 에이지락 미 상세</h2>

      <h3 class="rew19_third_title">주문 정보</h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>리워드 번호</em>
          <span class="substance">{{$nvl(viewData.adr_no,"-")}}</span>
        </li>
        <li class="type1">
          <em>자동 결제일</em>
          <span class="substance">
            <template v-if='$nvl(viewData.delivery_day,"") == ""'>
              <span class="gep_btnRight">-</span>
            </template>
            <template v-else>
              <span class="gep_btnRight">매월 {{$nvl(viewData.delivery_day,"-")}}일</span>
              <a @click="openChangeDeliveryDateDialog" class="rew19_btn_border">변경</a>
            </template>
          </span>
        </li>
        <li class="type1">
          <em>배송일</em>
          <span class="substance">결제 후 최대 3일 이내</span>
        </li>
        <li class="type1">
          <em>결제방법</em>
          <span class="substance">
            <span
              v-if='$nvl(viewData.payment_type,"") == AroConst.VALUE_payment_type_credit_card'
              class="gep_btnRight">{{$getContentPaymentType(viewData.payment_type)}} ({{viewData.print_cardnumber}})</span>
            <span
              v-if='$nvl(viewData.payment_type,"") == AroConst.VALUE_payment_type_account_transfer'
              class="gep_btnRight">{{$getContentPaymentType(viewData.payment_type)}} ({{viewData.bank_account}})</span>
            <a @click="openPaymentInfoDialog" class="rew19_btn_border">변경</a>
          </span>
        </li>
        <li class="type1">
          <em>진행회차</em>
          <span class="substance">{{$nvl(viewData.delivery_count,"-")}} 회</span>
        </li>
        <li class="type1">
          <em>스킨 케어 코드</em>
          <span class="substance">
            <span class="gep_btnRight">{{$nvl(viewData.agm_code,"-")}}</span>
            <a @click="openChangeSkinCareCodeDialog" class="rew19_btn_border">변경</a>
          </span>
        </li>
        <li v-if="viewData.rewardGrace_isShow" class="type1">
          <em>리워드 그레이스</em>
          <span class="substance">
            <span class="gep_btnRight">{{viewData.rewardGrace_status}}</span>
            <a v-if="viewData.rewardGrace_isShowBtn"
              @click="onClickRewardGrace"
              class="rew19_btn_border">{{viewData.rewardGrace_btnTitle}}</a>
          </span>
        </li>
        <li v-if="viewData.rewardMileagePayment_isShow" class="type1">
          <em>리워드 마일리지 결제</em>
          <span class="substance">
            <span class="gep_btnRight">{{viewData.rewardMileagePayment_status}}</span>
            <a v-if="viewData.rewardMileagePayment_isShowBtn"
              @click="onClickRewardMileagePayment"
              class="rew19_btn_border">{{viewData.rewardMileagePayment_btnTitle}}</a>
          </span>
        </li>
      </ul>

      <h3 class="rew19_third_title">
        배송 정보
        <a @click="openChangeShipInfoDialog" class="rew19_btn_T1 inthird">
          <span>변경</span>
        </a>
      </h3>
      <ul class="rew19_underline_list">
        <li class="type1">
          <em>수령인</em>
          <span class="substance">{{$nvl(viewData.ship_name,"-")}}</span>
        </li>
        <li class="type1">
          <em>전화 번호</em>
          <span class="substance">{{$nvl(viewData.home_phone,"-")}}</span>
        </li>
        <li class="type1">
          <em>핸드폰 번호</em>
          <span class="substance">{{$nvl(viewData.hand_phone,"-")}}</span>
        </li>
        <li class="type1">
          <em>주소</em>
          <span class="substance">({{$nvl(viewData.ship_zip1,"")}}{{$nvl(viewData.ship_zip2,"")}})
            {{$nvl(viewData.ship_address1,"")}} {{$nvl(viewData.ship_address2,"")}}</span>
        </li>
      </ul>

      <div class="rew19_responsive_btns gepTaye1">
        <a @click="onClickWithdraw" class="rew19-btn-normal">철회하기</a>
        <router-link :to="{name:'agelocCurrentList'}" class="rew19-btn-border">목록</router-link>
      </div>
    </div>
    <!--rew19_contents_inner-->

    <delivery-date-dialog
      :show="deliveryDateDialogShow"
      @close="changeDeliveryDate"
      ref="deliveryDateDialog"
    ></delivery-date-dialog>

    <payment-info-dialog
      :show="paymentInfoDialogShow"
      :mode="paymentInfoDialog.mode"
      :showCardTerm="true"
      :showInstMonth="false"
      :showReceiptNo="false"
      @close="changePaymentInfo"
      ref="paymentInfoDialog"
    ></payment-info-dialog>

    <skin-care-code-dialog
      :show="skinCareCodeDialogShow"
      @close="changeSkinCareCode"
      ref="skinCareCodeDialog"
    ></skin-care-code-dialog>

    <ship-info-dialog
      :show="shipInfoDialogShow"
      @close="changeShipInfo"
      ref="shipInfoDialog"
    ></ship-info-dialog>

    <ageloc-reward-grace-dialog
      :show="agelocRewardGraceDialogShow"
      @close="onCloseRewardGrace"
      ref="agelocRewardGraceDialog"
    ></ageloc-reward-grace-dialog>

    <ageloc-reward-mileage-payment-dialog
      :show="agelocRewardMileagePaymentDialogShow"
      @close="onCloseRewardMileagePayment"
      ref="agelocRewardMileagePaymentDialog"
    ></ageloc-reward-mileage-payment-dialog>

  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import DeliveryDateDialog from '@/components/popup/DeliveryDateDialog';
import PaymentInfoDialog from '@/components/popup/PaymentInfoDialog';
import SkinCareCodeDialog from '@/components/popup/SkinCareCodeDialog';
import ShipInfoDialog from '@/components/popup/ShipInfoDialog';

import AgelocRewardGraceDialog from '@/components/popup/AgelocRewardGraceDialog';
import AgelocRewardMileagePaymentDialog from '@/components/popup/AgelocRewardMileagePaymentDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as Crypto from '@/utils/cryptoUtil';

import DF from 'dateformat';

export default {
  name: "AgelocCurrentDetail",
  extends: AroBase,
  components: {
    DeliveryDateDialog,
    PaymentInfoDialog,
    SkinCareCodeDialog,
    ShipInfoDialog,

    AgelocRewardGraceDialog,
    AgelocRewardMileagePaymentDialog
  },
  computed: {
    isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
    adr_no: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      //View Data
      viewData : {

      },
      params : {},

      //popup
      //배송일 변경
      deliveryDateDialogShow : false,
      deliveryDateDialog : {},

      //결제정보
      paymentInfoDialogShow : false,
      paymentInfoDialog : {},

      skinCareCodeDialogShow : false,
      skinCareCodeDialog : {},

      //배송지 변경
      shipInfoDialogShow : false,
      shipInfoDialog : {},

      //에이지락미 리워드 그레이스
      agelocRewardGraceDialogShow : false,
      agelocRewardGraceDialog : {},

      //에이지락미 리워드 마일리지
      agelocRewardMileagePaymentDialogShow : false,
      agelocRewardMileagePaymentDialog : {},

      testText : ""
    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadDetail();
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI(){

    },

    /**
     * API Request
     */
    //나의 에이지락 미 정보 가져오기
    apiGetAgelocmeDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_agelocme_detail`, {
        params: {
          adr_no : _this.adr_no
        }
      });
    },

    //배송일 변경처리
    apiChangeAgeLocMeDeliveryDate(deliveryDay, chdeliveryDay){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_agelocme_delivery_date`, {
        params: {
          adr_no : _this.adr_no,
          delivery_day: deliveryDay,
          chdelivery_day: chdeliveryDay
        }
      });
    },

    //배송지 변경처리
    apiChangeAgeLocMeDelivery(addrInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_agelocme_delivery`, {
        params: {
          adr_no : _this.adr_no,
          ship_name : addrInfo.shipName,
          ship_tel : addrInfo.phoneNumber,
          ship_phone: addrInfo.phoneNumber,
          postal_cd1: addrInfo.zipCode.substring(0,3),
          postal_cd2: addrInfo.zipCode.substring(3),
          home_addr: addrInfo.firstAddress,
          home_addr_detail: addrInfo.lastAddress,
        }
      });
    },

    //결제정보 변경처리
    apiChangeAgeLocMePayment(paymentInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_agelocme_payment`, {
        params: {
          adr_no : _this.adr_no,
          ...paymentInfo
        }
      });
    },

    //스킨케이 코드 변경처리
    apiChangeAgeLocMeSkincare(skincareInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_agelocme_skincare`, {
        params: {
          adr_no : _this.adr_no,
          agm_code: skincareInfo.agm_code,
          agm_name: skincareInfo.agm_name,
          agm_detail: skincareInfo.agm_detail,
        }
      });
    },

    //그레이스 변경
    apiChangeGrace(graceUse){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_grace`, {
        params: {
          adr_no : _this.adr_no,
          grace_use: graceUse
        }
      });
    },

    //리워드 마일리지 변경
    apiChangeMileagePayment(useMileage, payInfo){
      let _this = this;

      let params =  {
        adr_no : _this.adr_no,
        mileage_use: useMileage
      };
      if("Y" == useMileage){
        params = {
          ...payInfo,
          ...params
        };
      }

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_mileage`, {
        params: params
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadDetail(){
      let _this = this;

      //show loading
      _this.$showLoading();

      _this.apiGetAgelocmeDetail().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {

          _this.viewData = {
            ...res.data
            ,cardnumber : Crypto.replaceStringForCardNumber(res.data.cardnumber, res.data, _this.getMemberId())
            ,birth : Crypto.replaceStringForBirth(res.data.birth, res.data, _this.getMemberId())
            ,fcardnumber : Crypto.replaceStringForCardNumber(res.data.fcardnumber, res.data, _this.getMemberId())
            ,fbirth : Crypto.replaceStringForBirth(res.data.fbirth, res.data, _this.getMemberId())

            //리워드 그레이스
            ,rewardGrace_isShow : false
            ,rewardGrace_status : ""
            ,rewardGrace_isShowBtn : false
            ,rewardGrace_btnTitle : ""

            //리워드 마일리지 결제
            ,rewardMileagePayment_isShow : false
            ,rewardMileagePayment_status : ""
            ,rewardMileagePayment_isShowBtn : false
            ,rewardMileagePayment_btnTitle : ""
          };

          { //리워드 그레이스 설정
            let graceStatus = _this.viewData.grace_status;
            _this.viewData.rewardGrace_isShow =
              _this.AroConst.VALUE_grace_status_CANCEL == graceStatus ||
              _this.AroConst.VALUE_grace_status_APPLY == graceStatus ||
              _this.AroConst.VALUE_grace_status_DISABLE == graceStatus ||
              _this.AroConst.VALUE_grace_status_CANCEL_DISABLE == graceStatus;

            if(_this.viewData.rewardGrace_isShow){
              var iAddPayTyMonth = _this.viewData.addpaytymonth;
              switch(graceStatus){
                case _this.AroConst.VALUE_grace_status_APPLY:
                  _this.viewData.rewardGrace_btnTitle = "리워드 그레이스 사용";
                  _this.viewData.rewardGrace_status = "사용가능";
                  _this.viewData.rewardGrace_isShowBtn = true;
                  break;
                case _this.AroConst.VALUE_grace_status_CANCEL:
                  _this.viewData.rewardGrace_btnTitle = "리워드 그레이스 취소";
                  _this.viewData.rewardGrace_status = ""+iAddPayTyMonth;
                  _this.viewData.rewardGrace_isShowBtn = true;
                  break;
                case _this.AroConst.VALUE_grace_status_CANCEL_DISABLE:
                  _this.viewData.rewardGrace_btnTitle = "리워드 그레이스 취소";
                  _this.viewData.rewardGrace_status = _this.viewData.grace_message;
                  _this.viewData.rewardGrace_isShowBtn = false;
                  break;
                case _this.AroConst.VALUE_grace_status_DISABLE:
                  _this.viewData.rewardGrace_btnTitle = "리워드 그레이스";
                  _this.viewData.rewardGrace_status = "사용불가";
                  _this.viewData.rewardGrace_isShowBtn = false;
                  break;
              }
            }
          }

          { //리워드 마일리지 결제 설정
            let mileageStatus = _this.viewData.mileage_status;
            _this.viewData.rewardMileagePayment_isShow =
              _this.AroConst.VALUE_mileage_status_CANCEL == mileageStatus ||
              _this.AroConst.VALUE_mileage_status_APPLY == mileageStatus ||
              _this.AroConst.VALUE_mileage_status_DISABLE == mileageStatus ||
              _this.AroConst.VALUE_mileage_status_CANCEL_DISABLE == mileageStatus;

            if(_this.viewData.rewardMileagePayment_isShow){
              let iFDeliveryType = _this.viewData.fdeliverytype;
              let usingMileage = "사용예정";
              switch(iFDeliveryType){
                case _this.AroConst.VALUE_fdeliverytype_CREDIT_CARD:
                  usingMileage = ` ( ${_this.AroConst.VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AMOUNT} 사용예정 )`;
                  break;
                case _this.AroConst.VALUE_fdeliverytype_MILEAGE:
                  usingMileage = ` ( ${_this.AroConst.VALUE_AGE_LOC_ME_CUSTOM_PRODUCT_MILEAGE_AND_DELIVERY_AMOUNT} 사용예정 )`;
                  break;
                default :
                  usingMileage = " 사용예정";
                  break;
              }

              switch(mileageStatus){
                case _this.AroConst.VALUE_mileage_status_APPLY:
                  _this.viewData.rewardMileagePayment_btnTitle = "리워드 마일리지 결제 사용";
                  _this.viewData.rewardMileagePayment_status = "사용가능";
                  _this.viewData.rewardMileagePayment_isShowBtn = true;
                  break;
                case _this.AroConst.VALUE_mileage_status_CANCEL:
                  _this.viewData.rewardMileagePayment_btnTitle = "리워드 그레이스 신청 취소";
                  _this.viewData.rewardMileagePayment_status = "신청중" + usingMileage;
                  _this.viewData.rewardMileagePayment_isShowBtn = true;
                  break;
                case _this.AroConst.VALUE_mileage_status_CANCEL_DISABLE:
                  _this.viewData.rewardMileagePayment_btnTitle = "리워드 그레이스 취소";
                  _this.viewData.rewardMileagePayment_status = _this.viewData.mileage_message + usingMileage;
                  _this.viewData.rewardMileagePayment_isShowBtn = false;
                  break;
                case _this.AroConst.VALUE_mileage_status_DISABLE:
                  _this.viewData.rewardMileagePayment_btnTitle = "리워드 그레이스";
                  _this.viewData.rewardMileagePayment_status = "사용불가";
                  _this.viewData.rewardMileagePayment_isShowBtn = false;
                  break;
              }
            }
          }

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();

      });
    },

    //Open dialog 배송일 변경
    openChangeDeliveryDateDialog(){
      let _this = this;

      //pass data to dialog
      let aroData = _this.viewData;
      _this.deliveryDateDialog = {
        ..._this.deliveryDateDialog,
        delivery_day : aroData.delivery_day,
        delivery_days_current : aroData.delivery_days_current,
        delivery_days_next : aroData.delivery_days_next
      };

      _this.$refs.deliveryDateDialog.initData(_this.deliveryDateDialog);
      _this.deliveryDateDialogShow = true;
    },

    //배송일 변경
    changeDeliveryDate(isOk, data){
      let _this = this;

      _this.deliveryDateDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let aroData = _this.viewData;
      if(aroData.delivery_day == data.delivery_day_current &&
        aroData.delivery_day == data.delivery_day_next)
      { //변경할 필요가 없음
        _this.$dialogs.alert("배송일이 기존과 동일하여, 배송일을 변경하지 않았습니다.")
        .then(res => {});
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiChangeAgeLocMeDeliveryDate(data.delivery_day_current, data.delivery_day_next)
      .then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제일 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //Open Dialog결제정보 변경
    openPaymentInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.paymentInfoDialog = {
        //..._this.paymentInfoDialog,
        mode : 0, //신용카드, 계좌이체 모두
        paymentType : parseInt(_this.viewData.payment_type, 10),
        card :{
          birth : _this.viewData.birth,
          cardnumber : _this.viewData.cardnumber,

          useTerm : _this.$aroApiBasePath + _this.AroConst.VALUE_AGG_LOC_ME_CARD_USE_TERM
        },
        account:{

        }
      };
      _this.$refs.paymentInfoDialog.initData(_this.paymentInfoDialog);
      _this.paymentInfoDialogShow = true;
    },

    //결제정보 변경
    changePaymentInfo(isOk, data){
      let _this = this;

      _this.paymentInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let paymentInfo = {
        payment_type : data.paymentType
      };
      if(data.paymentType == 2){
        paymentInfo = {
          ...paymentInfo,
          birth_dt : data.card.birth,
          card_no : data.card.cardnumber,
          card_exp : data.card.expYY + data.card.expMM,
          passwd : data.card.pwd,
        }
      }else if(data.paymentType == 3){
        paymentInfo = {
          ...paymentInfo,
          cms_no : data.account.cms_no,
          birth_dt : data.account.birth
        }
      }

      //show loading
      _this.$showLoading();
      _this.apiChangeAgeLocMePayment(paymentInfo).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{

        //hide loading
        _this.$hideLoading();
      });
    },

    //Open dialog 스킨 케어 코드
    openChangeSkinCareCodeDialog(){
      let _this = this;

      //pass data to dialog
      _this.skinCareCodeDialog = {
        ..._this.skinCareCodeDialog,
        memberId : _this.getMemberId(),
        agm_code : _this.viewData.agm_code,
        agm_name : _this.viewData.agm_name,
        agm_detail : _this.viewData.agm_detail
      };

      _this.$refs.skinCareCodeDialog.initData(_this.skinCareCodeDialog);

      _this.skinCareCodeDialogShow = true;
    },

    //스킨 케어 코드 변경
    changeSkinCareCode(isOk, data){
      let _this = this;

      _this.skinCareCodeDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiChangeAgeLocMeSkincare(data)
      .then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("스킨케어 코드정보 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });


    },

    //Open dialog 배송 정보 변경
    openChangeShipInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.shipInfoDialog = {
        ..._this.shipInfoDialog,
        memberId : _this.getMemberId()
      };

      _this.$refs.shipInfoDialog.initData(_this.shipInfoDialog);
      _this.shipInfoDialogShow = true;
    },

    //배송 정보 변경
    changeShipInfo(isOk, data){
      let _this = this;

      _this.shipInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiChangeAgeLocMeDelivery(data).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("배송지 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //철회하기
    onClickWithdraw(){
      let _this = this;

      _this.$router.push(`${_this.$aroBasePath}/agelocWithdraw?adr_no=${_this.adr_no}`);

      /*
      const options = {cancelLabel: '취소', okLabel:'확인'};
      let msg = `${_this.adr_no}의 리워드 프로그램을 철회 하시겠습니까?`;
      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          _this.$router.push(`${_this.$aroBasePath}/agelocWithdraw?adr_no=${_this.adr_no}`);
        }
      });
      */
    },

    // 리워드 그레이스
    onClickRewardGrace(){
      let _this = this;
      let graceStatus = _this.viewData.grace_status;

      if (_this.AroConst.VALUE_grace_status_APPLY == graceStatus) {
        // 리워드 그레이스 Dialog
        _this.agelocRewardGraceDialog = {
          useLog : _this.$nvl(_this.viewData.use_date, "-"),
          applyMonth : _this.$nvl(_this.viewData.addpaymentgracedescription, "-")
        }
        _this.$refs.agelocRewardGraceDialog.initData(_this.agelocRewardGraceDialog);
        _this.agelocRewardGraceDialogShow = true;

      } else if (_this.AroConst.VALUE_grace_status_CANCEL == graceStatus) {
        //취소하기
        const options = {cancelLabel: '취소', okLabel:'확인'};
        let msg = `리워드 그레이스가 사용을 취소 하시겠습니까?`;
        _this.$dialogs.confirm(msg, options).then(res=>{
          if(res.ok){
            _this.reqRewardGrace("N");
          }
        });

      } else if (_this.AroConst.VALUE_grace_status_CANCEL_DISABLE == graceStatus) {
        //취소불가
        //_this.$dialogs.alert("리워드 그레이스가 사용을 취소가 불가합니다.").then(res => {});
      }
    },

    //리워드 그레이스 Dialog 닫기
    onCloseRewardGrace(isOk, data){
      let _this = this;

      _this.agelocRewardGraceDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.reqRewardGrace("Y");
    },

    //리워드 그레이스 처리
    reqRewardGrace(useRewardGrace){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiChangeGrace(useRewardGrace).then(res=>{

        if (res.status === 200 && (res.data.status === "0000" || res.data.status === "000")) {
          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    // 리워드 마일리지 결제
    onClickRewardMileagePayment(){
      let _this = this;
      let mileageStatus = _this.viewData.mileage_status;

      if (_this.AroConst.VALUE_mileage_status_APPLY == mileageStatus) {
        // 마일리지 결제  dialog

        _this.agelocRewardMileagePaymentDialog = {
          adr_no : _this.adr_no,
          aro_info : _this.viewData
        };
        _this.$refs.agelocRewardMileagePaymentDialog.initData(_this.agelocRewardMileagePaymentDialog);
        _this.agelocRewardMileagePaymentDialogShow = true;

      } else if (_this.AroConst.VALUE_mileage_status_CANCEL == mileageStatus) {
        //취소하기
        const options = {cancelLabel: '취소', okLabel:'확인'};
        let msg = `리워드 마일리지 결제를 취소 하시겠습니까?`;
        _this.$dialogs.confirm(msg, options).then(res=>{
          if(res.ok){
            _this.reqRewardMileagePayment("N");
          }
        });

      } else if (_this.AroConst.VALUE_mileage_status_CANCEL_DISABLE == mileageStatus) {
        //취소불가
        //_this.$dialogs.alert("리워드 마일리지 결제를 취소가 불가합니다.").then(res => {});
      }
    },

     //리워드 마일리지 결제 Dialog 닫기
    onCloseRewardMileagePayment(isOk, data){
      let _this = this;

      _this.agelocRewardMileagePaymentDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //console.debug(`onCloseRewardMileagePayment res:${isOk},data:${JSON.stringify(data, null, 4)}`);
       _this.reqRewardMileagePayment("Y", data);
    },

    //리워드 마일리지 결제 처리
    reqRewardMileagePayment(useMileage, payInfo){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiChangeMileagePayment(useMileage, payInfo).then(res=>{

        if (res.status === 200 && (res.data.status === "0000" || res.data.status === "000")) {
          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
a.rew19-btn-normal a.rew19_btn_T1, a.rew19_btn_border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/ageloc/currentDetail.vue